var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.375 9.66667C9.75468 9.66667 10.0625 9.97448 10.0625 10.3542C10.0625 10.7339 9.75468 11.0417 9.375 11.0417H6.625C6.24532 11.0417 5.9375 10.7339 5.9375 10.3542C5.9375 9.97448 6.24532 9.66667 6.625 9.66667H9.375ZM12.125 5.08333C12.5047 5.08333 12.8125 5.39115 12.8125 5.77083C12.8125 6.15052 12.5047 6.45833 12.125 6.45833H3.875C3.49531 6.45833 3.1875 6.15052 3.1875 5.77083C3.1875 5.39115 3.49531 5.08333 3.875 5.08333H12.125ZM14.875 0.5C15.2547 0.5 15.5625 0.807808 15.5625 1.1875C15.5625 1.56719 15.2547 1.875 14.875 1.875H1.125C0.745308 1.875 0.4375 1.56719 0.4375 1.1875C0.4375 0.807808 0.745308 0.5 1.125 0.5H14.875Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.432909414297260dec9695ceac2bd69d.svg";
export { ForwardRef as ReactComponent };